import React from "react";
import AboutUsHeader from "./AboutUsHeader";
import ProudHistory from "./ProudHistory";
import PreFooterCards from "./PreFooterCards";
import Testimonials from "./Testimonials";
import IsoCertificateSection from "./IsoCertificateSection";
// import ChooseUs from "./ChooseUs";
// import TransformingWorkplace from "./TransformingWorkplace";
// import SmartSolutions from "./SmartSolutions";
// import EmpoweringPartnerships from "./EmpoweringPartnerships";

const MainAbout = () => {
  return (
    <div>
      <AboutUsHeader />
      <ProudHistory />
      <IsoCertificateSection />
      <Testimonials />
      {/* <TransformingWorkplace />
      <SmartSolutions />
      <EmpoweringPartnerships />
      <ChooseUs /> */}
      <PreFooterCards />
    </div>
  );
};

export default MainAbout;
